<template>
    <div v-if="mixer" class="mixer" ref="test">
        <div class="mixer-name">Mixer: {{ mixer.mix_nombre }}</div>
        <div class="mixer-block" v-for="item in horas" :key="item" :id="mixer.mix_id + '-' + item"></div>
    </div>
</template>

<script>
import DateTime from "../../util/dateTime"
import EnvioItem from "./EnvioItem"
import Vue from 'vue'

export default {
    name: "MixerItem",
    components: {
        EnvioItem
    },
    props: {
        mixer: {
            type: Object
        },
        estados: {
            type: Array
        }
    },
    data() {
        return {
            horas: DateTime.horas
        }
    },
    methods: {
        renderizarEnvios() {
            if (this.mixer) {
                if (this.mixer.envios && this.mixer.envios.length) {
                    this.mixer.envios.forEach(envio => {
                        // la posicion inicial del envio
                        const posicion = this.obtenerPosicionInicial(envio)
                        // cuanto se va a desplazar el envio desde su posicion inicial
                        const offset = this.obtenerOffset(envio)
                        // obteniendo una instancia de EnvioItem
                        const ComponentClass = Vue.extend(EnvioItem)
                        const instance = new ComponentClass({
                            // enviando datos hacia data
                            data: {
                                envio,
                                estados: this.estados,
                                offset
                            }
                        })
                        // colocando la instancia en la posicion inicial
                        instance.$mount()
                        document.getElementById(this.mixer.mix_id + "-" + posicion).appendChild(instance.$el)
                    })
                }
            }
        },
        obtenerPosicionInicial(envio) {
            const source = DateTime.convertStringToObject(envio.env_fecha_hora_carguio)
            return source.hour + ":00"
        },
        obtenerOffset(envio) {
            const source = DateTime.convertStringToObject(envio.env_fecha_hora_carguio)
            return String(source.min).startsWith("0")
                ? String(source.min).substring(1)
                : source.min
        }
    },
    mounted() {
        this.renderizarEnvios()
    }
}
</script>

<style scoped>
.mixer {
    display: grid;
    grid-template-columns: 1fr;
}

.mixer-name {
    background-color: var(--nj-color-blue);
    color: #fff;
    padding: 8px 10px;
    border-right: 1px solid #fff;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 30px;
}

.mixer-name:last-child {
    border-right: 1px solid var(--nj-color-blue);
}

.mixer-block {
    position: relative;
    height: 30px;
    background-color: #fafafa;
    border: 1px solid #ccc;
    border-width: 0 1px 1px 0;
    text-align: center;
}
</style>